import * as types from './Help.types';
import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';
import Store from '../../../redux/Store';

export const getHelpList = () => {
  const { help } = Store.getState();

  if (!help) {
    return Helpers.get(Constants.HELPLIST_URL);
  } else {
    return Promise.resolve(help);
  }
};

export const getHelpListSuccess = help => ({ type: types.GET_HELP_LIST_SUCCESS, help });
